import React, {
  useState,
  useEffect,
  useRef,
  useContext,
  useCallback
} from 'react'
import Widget from '../../dpe-usco/components/Widget/Widget'
import Table from '../../dpe-usco/components/Table/Table'
import { Modal } from 'syngenta-react-components'
import clear from '../../assets/icons/clear.svg'
import info from '../../assets/icons/info.svg'
import { Button } from 'syngenta-react-components'
import { GlobalContext } from '../../services/context'
import { getFieldBoundaryCenter } from '../../services/utils'

const disabledStyle = 'bgc-lightgray'

const onSubmit = e => {
  e.preventDefault()
}

/* eslint-disable */

const headerContent = value => {
  return (
    <div key={value} className="cell df aic">
      <span className="cell">{value}</span>
    </div>
  )
}

const Field = ({
  farmArray,
  fieldArray,
  getFieldRowData,
  updateFields,
  contractYear,
  _defaultFields,
  setTotalAPH,
  setDefaultAphEvent,
  setResetDeliveryTable,
}) => {
  const { trackEvent } = useContext(GlobalContext)
  const [rowInputs, setRowInputs] = useState({})
  const [sameYield, setSameYield] = useState(true)

  const [showModal, setShowModal] = useState(false)
  const prevYield = useRef()

  const [totalYield, setTotalYield] = useState()
  const [totalAcresValue, setTotalAcresValue] = useState()
  const [isTotalAcresChecked, setIsTotalAcresChecked] = useState(true)
  
  const [totalTableData, setTotalTableData] = useState([{
    aph: 0,
    border_rows: false,
    field_acres: '0',
    field_boundary: 'N/A',
    field_id: 'total_enogen_acres_id',
    field_name: 'Total Enogen Acres',
    planting_rate: 0
  }])

  const [totalAcresRowInputs,setTotalAcresRowInputs] =useState({ total_enogen_acres_id:{
    aph: 0,
    border_rows: false,
    field_acres: '0',
    field_boundary: 'N/A',
    field_id: 'total_enogen_acres_id',
    field_name: 'Total Enogen Acres',
    planting_rate: 0
  } })

  const [totalAcresVal, setTotalAcresVal] = useState(0)
  const [totalYieldVal, setTotalYieldVal] = useState(0)

  useEffect(()=>{
    let yieldValue = 0
    let totalAcresValue = 0
  
    yieldValue = Number.isInteger(yieldValue) ? yieldValue.toString() : yieldValue.toFixed(2)
    if(isNaN(yieldValue)){
      yieldValue = 0
    } 
    setTotalYield(yieldValue)
    setTotalAcresValue(totalAcresValue)
  }, [, rowInputs])

  useEffect(()=>{
    if(!isTotalAcresChecked) {
      updateFields({ type: 'UPDATE_FIELD_APH_PLANTING_RATE', payload: false })
      updateFields({
        type: 'CLEAR_ERROR',
        payload: { field_aph_planting_rate: { empty: false } }
      })
    } else {
      updateFields({ type: 'UPDATE_FIELD_APH_PLANTING_RATE', payload: false })
      updateFields({
        type: 'CLEAR_ERROR',
        payload: { field_aph_planting_rate: { empty: false } }
      })
    }
  }, [ rowInputs, isTotalAcresChecked, updateFields])

  useEffect(()=>{
    let result=totalYield/totalAcresValue
    if(isFinite(result)){
      setTotalAPH(result)
    }else{
      setTotalAPH(0)
    }
  }, [totalYield, totalAcresValue, setTotalAPH])


  const checkboxTracker = useCallback(
    (quantity, status, value) => {
      const eventType = `${quantity}_${status}`
      let eventProperties = {}
      if (quantity === 'farm') {
        eventProperties.farmId = farmArray[value].farm_id
      } else {
        eventProperties.fieldId = value
      }
      trackEvent(eventType, eventProperties)
    },
    [farmArray, trackEvent]
  )

  const prevCheckboxData = useRef({})
  useEffect(() => {
    const farms = {}
    const prevFarms = {}
    let changedField
    for (let fieldId in prevCheckboxData.current) {
      const field = prevCheckboxData.current[fieldId]
      if (prevFarms[field.index]) {
        prevFarms[field.index] = prevFarms[field.index] + (field.value ? 1 : 0)
      } else {
        prevFarms[field.index] = field.value ? 1 : 0
      }
    }
    for (let index in farms) {
      if (prevFarms[index] !== undefined) {
        if (prevFarms[index] - farms[index] === 1) {
          checkboxTracker('field', 'unchecked', changedField)
        } else if (prevFarms[index] - farms[index] > 1) {
          checkboxTracker('farm', 'unchecked', index)
        } else if (prevFarms[index] - farms[index] < -1) {
          checkboxTracker('farm', 'checked', index)
        } else if (prevFarms[index] - farms[index] === -1) {
          checkboxTracker('field', 'checked', changedField)
        }
      } else {
        if (farms[index] > 1) {
          checkboxTracker('farm', 'checked', index)
        } else {
          checkboxTracker('field', 'checked', changedField)
        }
      }
    }

  }, [ checkboxTracker])


  useEffect(() => {
    if (_defaultFields?.size) {
      const newObj = {}
      const newCheckboxObj = {}
      const newObjArray = []
      _defaultFields.forEach(field => {
        const newFieldObj = {
          field_name: field.field_name,
          field_id: field.field_id,
          field_acres: field.acres,
          field_boundary: field.field_boundary,
          aph: field.average_yield,
          planting_rate: field.planting_rate,
          border_rows: field.border_rows
        }

        newObj[field.field_id] = newFieldObj
        newCheckboxObj[field.field_id] = {
          ...newCheckboxObj[field.field_id],
          value: true
        }
        newObjArray.push(newFieldObj)
      })
      setRowInputs(newObj)
    }
  }, [_defaultFields])

  const insertField = useCallback(() => {
    const fieldOutput = []
    for (let field in rowInputs) {
      let fieldCenter = getFieldBoundaryCenter(rowInputs[field].field_boundary)
      fieldCenter = fieldCenter ? fieldCenter : {
        'type': 'Feature',
        'geometry': {
          'type': 'Point',
          'coordinates': [
            -0.0,
            -0.0
          ]
        }
      }
      const newField = {
        field_name: rowInputs[field].field_name,
        field_id: rowInputs[field].field_id,
        planting_rate: rowInputs[field]?.planting_rate?.toString(),
        average_yield: rowInputs[field]?.aph?.toString(),
        border_rows: rowInputs[field].border_rows,
        acres: rowInputs[field].field_acres.toString(),
        crop_year: contractYear?.toString(),
        latitude: fieldCenter.geometry.coordinates[1].toString(),
        longitude: fieldCenter.geometry.coordinates[0].toString(),
        is_total: false
      }

      if (!!rowInputs[field]?.aph && !!rowInputs[field]?.planting_rate) {
        fieldOutput.push(newField)
      }
    }
    updateFields({ type: 'UPDATE_FIELDS', payload: fieldOutput })
    if (fieldOutput.length !== 0) {
      updateFields({
        type: 'CLEAR_ERROR',
        payload: { fields: { empty: false } }
      })
    }
  },[rowInputs, updateFields, contractYear])

  useEffect(() => {
    if (contractYear) {
      let empty = false
      if(empty){
        updateFields({ type: 'UPDATE_APH', payload: empty })
      } else{
        updateFields({ type: 'UPDATE_APH', payload: empty })
        updateFields({
          type: 'CLEAR_ERROR',
          payload: { aph_field_empty: { empty: false } }
        })
      }
    }
  }, [rowInputs, updateFields, contractYear])

  useEffect(() => {
    if (contractYear) {
      let empty = false
      if(empty){
        updateFields({ type: 'UPDATE_PLANTING', payload: empty })
      } else{
        updateFields({ type: 'UPDATE_PLANTING', payload: empty })
        updateFields({
          type: 'CLEAR_ERROR',
          payload: { planting_field_empty: { empty: false } }
        })
      }
    }
  }, [rowInputs, updateFields, contractYear])



  useEffect(() => {
    const newObj = {}
    if (fieldArray.length) {
      if (_defaultFields?.size) {
        fieldArray.forEach(field => {
          let aph = 0
          let planting_rate = 0
          if (_defaultFields.has(field.field_id)) {
            const currentField = _defaultFields.get(field.field_id)
            aph = currentField.average_yield
            planting_rate = currentField.planting_rate
          }
          newObj[field.field_id] = {
            field_name: field.field_name,
            field_id: field.field_id,
            field_acres: field.field_acres,
            field_boundary: field.field_boundary,
            aph,
            planting_rate,
            border_rows: false
          }
        })
      } else {
        fieldArray.forEach(field => {
          newObj[field.field_id] = {
            field_name: field.field_name,
            field_id: field.field_id,
            field_acres: field.field_acres,
            field_boundary: field.field_boundary,
            aph: 0,
            planting_rate: 0,
            border_rows: false
          }
        })
      }
      setRowInputs(newObj)
    }
  }, [_defaultFields, fieldArray])

  useEffect(() => {
    prevYield.current = sameYield
  })

  useEffect(() => {
    getFieldRowData(rowInputs)
  }, [getFieldRowData, rowInputs])


  const allowOnlyNumericsOrDigits = e => {		
    if (e.charCode >= 48 && e.charCode <= 57) return
    e.preventDefault()
  }

  const totalFieldsStructure = {
    headers: [
      {
        value: 'Field Name',
        format() {
          return headerContent(this.value)
        }
      },
      {
        value: 'Acres',
        format() {
          return headerContent(this.value)
        }
      },
      {
        value: 'Planting rate',
        format() {
          return headerContent(this.value)
        }
      },
      {
        value: 'Expected Yield',
        format() {
          return headerContent(this.value)
        }
      }
    ],
    dataKeys: [
      'field_name',
      'field_acres',
      'planting_rate',
      'aph'
    ],
    customMemoAreEqual: (prev, current) => {
      if (prev.field_id === current.field_id) {
        return true
      }
      return false
    },
    rowFormat: {
      field_acres: {
        allContent: true,
        format: field => {
          return (
            <input
              type="number"
              aria-label="field_acres"
              name={`${field.field_id}_field_acres`}
              min= "0"
              value={totalAcresRowInputs[field.field_id]?.field_acres}
              onChange={e => updateFieldTotalAcres(e, field.field_id, 'field_acres')}
              onKeyPress={e => allowOnlyNumericsOrDigits(e)}
            />
          )
        }
      },
      planting_rate: {
        allContent: true,
        format: field => {
          return (
            <input
              type="number"
              aria-label="planting_rate"
              name={`${field.field_id}_planting_rate`}
              min= "0"
              value={totalAcresRowInputs[field.field_id]?.planting_rate}
              onChange={e => updateFieldTotalAcres(e, field.field_id, 'planting_rate')}
              onKeyPress={e => allowOnlyNumericsOrDigits(e)}
            />
          )
        }
      },
      aph: {
        allContent: true,
        format: field => {
          return (
            <input
              type="number"
              disabled={field.yieldDisabled}
              className={field.yieldDisabled ? disabledStyle : ''}
              name={`${field.field_id}_aph`}
              aria-label="aph"
              min= "0"
              value={totalAcresRowInputs[field.field_id]?.aph}
              onChange={e => updateFieldTotalAcres(e, field.field_id, 'aph')}
              onKeyPress={e => allowOnlyNumericsOrDigits(e)}
            />
          )
        }
      }
    }
  }

  const TotalAcresBottomOfTable = (
    <>
      <div className="bt1-s-lightgray df jcfe aic h44 pl16 fz16 pr10 fwb">
        <div className="mr20">Total Acres {totalAcresVal}</div> 
        <div>Total Yield {totalYieldVal}</div>
      </div>
    </>
  )

  useEffect(()=>{
    if(_defaultFields?.size) {
      let totalAcres = 0;
      let totalPlantingRate = 0;
      let totalYeildingRate = 0;
      for (const [key, value] of _defaultFields) {
        if(key !== 'total_enogen_acres_id' ) {
          totalAcres += Number(value.acres)
          totalYeildingRate += Number(value.average_yield)
          totalPlantingRate += Number(value.planting_rate)
        }
      }      
      const totalEnogenExist = _defaultFields.has('total_enogen_acres_id')
      if(totalEnogenExist) {
        const field =  _defaultFields.get('total_enogen_acres_id')
        const newFieldObj = {
          aph: field.average_yield,
          farm_id: field.field_id,
          field_acres: field.acres,
          field_boundary: field.field_boundary,
          field_id: field.field_id,
          field_name: field.field_name,
          planting_rate: field.planting_rate,
          border_rows: false
        }  

        setIsTotalAcresChecked(true)
        setTotalAcresRowInputs({ total_enogen_acres_id: newFieldObj })
      }else{
        const newFieldObj = {
          aph: totalYeildingRate/_defaultFields.size,
          farm_id: "total_enogen_acres_id",
          field_acres: totalAcres,
          field_boundary: undefined,
          planting_rate: totalPlantingRate/_defaultFields.size,
          field_id : "total_enogen_acres_id",
          field_name : "Total Enogen Acres",
          border_rows: false
        }
        setIsTotalAcresChecked(true)
        setTotalAcresRowInputs({ total_enogen_acres_id: newFieldObj })
      }
    }
  },[_defaultFields])


  const insertTotalField = useCallback(() => {
    const fieldOutput = []
    for (let field in totalAcresRowInputs) {
      const newField = {
        field_name: totalAcresRowInputs[field].field_name,
        field_id: totalAcresRowInputs[field].field_id,
        planting_rate: totalAcresRowInputs[field].planting_rate?.toString(),
        average_yield: totalAcresRowInputs[field].aph.toString(),
        border_rows: totalAcresRowInputs[field].border_rows,
        acres: totalAcresRowInputs[field].field_acres.toString(),
        crop_year: contractYear?.toString(),
        latitude: '0',
        longitude: '0',
        is_total: true
      }

      if (!!totalAcresRowInputs[field].aph && !!totalAcresRowInputs[field].field_acres && !!totalAcresRowInputs[field].planting_rate) {
        fieldOutput.push(newField)
      }
    }
    updateFields({ type: 'UPDATE_FIELDS', payload: fieldOutput })
    if (fieldOutput.length !== 0) {
      updateFields({
        type: 'CLEAR_ERROR',
        payload: { fields: { empty: false } }
      })
    }
  },[totalAcresRowInputs, updateFields, contractYear])

  useEffect(() => {
    setResetDeliveryTable(isTotalAcresChecked)
  },[isTotalAcresChecked,setResetDeliveryTable])

  useEffect(() => {
    setSameYield(true)
    setDefaultAphEvent(true)
    setTotalAPH(0)
    if(isTotalAcresChecked){
      setTotalTableData([{
        aph: 0,
        border_rows: false,
        field_acres: '0',
        field_boundary: 'N/A',
        field_id: 'total_enogen_acres_id',
        field_name: 'Total Enogen Acres',
        planting_rate: 0
      }])
    
      setTotalAcresRowInputs({ total_enogen_acres_id:{
        aph: 0,
        border_rows: false,
        field_acres: '0',
        field_boundary: 'N/A',
        field_id: 'total_enogen_acres_id',
        field_name: 'Total Enogen Acres',
        planting_rate: 0
      } })

      const fieldOutput = []
      updateFields({ type: 'UPDATE_FIELDS', payload: fieldOutput })
      if (fieldOutput.length !== 0) {
        updateFields({
          type: 'CLEAR_ERROR',
          payload: { fields: { empty: false } }
        })
      }

    }
    else {
      let newObj = {}
      setRowInputs(objOfFields => {
        for (let field_id in objOfFields) {
          newObj[field_id] = {
            ...objOfFields[field_id],
            planting_rate: 0,
            aph:0,
            border_rows:false
          }
        }
        return newObj
      })
      const fieldOutput = []
      updateFields({ type: 'UPDATE_FIELDS', payload: fieldOutput })
      if (fieldOutput.length !== 0) {
        updateFields({
          type: 'CLEAR_ERROR',
          payload: { fields: { empty: false } }
        })
      }
    }
  },[isTotalAcresChecked,setSameYield,setDefaultAphEvent,
    setTotalAPH,setTotalTableData,setTotalAcresRowInputs,
    setRowInputs, updateFields
  ])

  useEffect(() => {
    if(isTotalAcresChecked){

      let totalTableData = [{
        aph: 0,
        farm_id: 'total_enogen_acres_id',
        field_acres: '0',
        field_boundary: 'N/A',
        field_id: 'total_enogen_acres_id',
        field_name: 'Total Enogen Acres',
        planting_rate: 0
      }]

      if(_defaultFields?.size) {
        _defaultFields.forEach(field => {
          const newFieldObj = {
            aph: field.average_yield,
            farm_id: field.field_id,
            field_acres: field.acres,
            field_boundary: field.field_boundary,
            field_id: field.field_id,
            field_name: field.field_name,
            planting_rate: field.planting_rate
          }
          if(field?.is_total !== undefined && field?.is_total === true) {
            totalTableData=[]
            totalTableData.push(newFieldObj)
          }         
        })
      } 
      setTotalTableData(totalTableData)
      insertTotalField()
    }
    else {
      setTotalTableData([])
      insertField()
    }
  },[isTotalAcresChecked, insertTotalField, insertField, _defaultFields])
  

  useEffect(() => {
    if(isTotalAcresChecked){
      setDefaultAphEvent(true)
      getFieldRowData(totalAcresRowInputs)
      setTotalAPH(totalAcresRowInputs['total_enogen_acres_id'].aph)
    }
    else{
      getFieldRowData(rowInputs)
      let result=totalYield/totalAcresValue
      if(isFinite(result)){
        setTotalAPH(result)
      }else{
        setTotalAPH(0)
      }
    }
  }, [getFieldRowData, totalAcresRowInputs, rowInputs, isTotalAcresChecked, setTotalAPH, totalYield, totalAcresValue, setDefaultAphEvent])

  useEffect(() => {
    getFieldRowData(totalAcresRowInputs)
  }, [getFieldRowData, totalAcresRowInputs])


  useEffect(() => {
    if (contractYear) {  
      let empty = false
      let aphEmpty = false
      let acresEmpty = false
      let aphRangeEmpty = false

      if(!totalTableData.length && isTotalAcresChecked){
        empty = true
        aphEmpty = true
        acresEmpty = true
        aphRangeEmpty = true
      }
      for (let field in totalAcresRowInputs) { 
        const index = totalTableData.findIndex(data => data.field_id === field)
        if(index !== -1){
          if((totalAcresRowInputs[field].planting_rate === '' || Number(totalAcresRowInputs[field].planting_rate) === 0) && (isTotalAcresChecked)){
            empty = true
          }

          if((totalAcresRowInputs[field].aph === '' || Number(totalAcresRowInputs[field].aph) === 0) && (isTotalAcresChecked)){
            aphEmpty = true
          }

          if((totalAcresRowInputs[field].aph !== '' && (Number(totalAcresRowInputs[field].aph) < 50 || Number(totalAcresRowInputs[field].aph) > 300)) && (isTotalAcresChecked)){
            aphRangeEmpty = true
          }

          if((totalAcresRowInputs[field].field_acres === '' || Number(totalAcresRowInputs[field].field_acres) === 0) && (isTotalAcresChecked)){
            acresEmpty = true
          }
        }
      }
      if(empty){
        updateFields({ type: 'UPDATE_PLANTING', payload: empty })
      } else{
        updateFields({ type: 'UPDATE_PLANTING', payload: empty })
        updateFields({
          type: 'CLEAR_ERROR',
          payload: { planting_field_empty: { empty: false } }
        })
      }

      if(aphEmpty){
        updateFields({ type: 'UPDATE_APH', payload: aphEmpty })
      } else{
        updateFields({ type: 'UPDATE_APH', payload: aphEmpty })
        updateFields({
          type: 'CLEAR_ERROR',
          payload: { aph_field_empty: { empty: false } }
        })
      }

      if(aphRangeEmpty){
        updateFields({ type: 'UPDATE_APH_RANGE', payload: aphRangeEmpty })
      } else{
        updateFields({ type: 'UPDATE_APH_RANGE', payload: aphRangeEmpty })
        updateFields({
          type: 'CLEAR_ERROR',
          payload: { aph_range_field_empty: { empty: false } }
        })
      }

      if(acresEmpty){
        updateFields({ type: 'UPDATE_ACRES', payload: acresEmpty })
      } else{
        updateFields({ type: 'UPDATE_ACRES', payload: acresEmpty })
        updateFields({
          type: 'CLEAR_ERROR',
          payload: { acres_field_empty: { empty: false } }
        })
      }
    }
  }, [totalAcresRowInputs, updateFields, contractYear, totalTableData, isTotalAcresChecked])

  const updateFieldTotalAcres = (e, field_id, key) => {
    const temp = { ...e }
    if(key === 'aph')
      setTotalAPH(temp.target.value)
    setTotalAcresRowInputs(prev => {
      return {
        ...prev,
        [field_id]: { ...prev[field_id], [key]: temp.target.value }
      }
    })
  }

  useEffect(()=>{
    let yieldValue = 0
    let totalAcresValue = 0
    for (let field in totalAcresRowInputs) { 
      const index = totalTableData.findIndex(data => data.field_id === field)
      if(index !== -1){
        yieldValue += Number(totalAcresRowInputs[field].aph) * Number(totalAcresRowInputs[field].field_acres)
        totalAcresValue += Number(totalAcresRowInputs[field].field_acres)
      }
    }
    
    yieldValue = Number.isInteger(yieldValue) ? yieldValue.toString() : yieldValue.toFixed(2)
    totalAcresValue = Number.isInteger(totalAcresValue) ? totalAcresValue.toString() : totalAcresValue.toFixed(2)
    setTotalYieldVal(yieldValue)
    setTotalAcresVal(totalAcresValue)
  }, [totalTableData, totalAcresRowInputs])

  return (
    <Widget title="Fields" dataTestId="fieldWithTable">
      <form onSubmit={onSubmit}>
        <div className="df mt25 mb20">
          <div className="flx1 mah700" data-testid="tableInFieldWidget">
            <Table
              data={totalTableData}
              structure={totalFieldsStructure}   
              bottomOfTable={TotalAcresBottomOfTable}
            />
          </div> 
        </div>
      </form>
      <Modal
        autoHeight
        show={showModal}
        handleClose={() => setShowModal(false)}
      >
        <div className="w100% h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4">
          <div className="df jcsb">
            <p className="fz16 ml16 fw600">Should you include border rows?</p>
            <button
              className="bdnone m0 bgc-t"
              onClick={() => setShowModal(false)}
            >
              <img src={clear} alt="close modal" />
            </button>
          </div>
          <hr className="mt0 mb16 bdnone bt1-s-lightgray" />

          <div className="df aic w100%">
            <img src={info} alt="more info" className="w10% ml20" />
            <p className="w80% mr20">
              Enogen fields require 30’ of spatial isolation from any adjacent
              annual crop. If no natural isolation exists, a 30’ width of border
              rows consisting of a non-Enogen corn hybrid must be planted next
              to that adjacent crop (only), and be considered part of the Enogen
              field. Please indicate whether each individual field require at
              least some length of border rows.
            </p>
          </div>
          <hr className="mt0 mb16 bdnone bt1-s-lightgray" />
          <div className="w100% tar">
            <Button
              customClassName="mr10"
              styleType="success"
              text="Close"
              clickHandler={() => setShowModal(false)}
            />
          </div>
        </div>
      </Modal>
    </Widget>
  )
}
export default Field